import React from 'react'
import { TextField, Checkbox } from "@material-ui/core"
import Autocomplete from '@material-ui/lab/Autocomplete'
import { ThemeProvider, createTheme } from "@material-ui/core/styles"

import { addFleetGearsOptions, addFleetVesselTypeOptions } from '../../constants'

import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import CheckBoxIcon from '@material-ui/icons/CheckBox'

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
const checkedIcon = <CheckBoxIcon fontSize="small" />

const compactTheme = createTheme({
    overrides: {
        MuiInputBase: {
            root: {
                height: 28,
                fontSize: "11px",
                paddingRight: 4
            },
            input: {
                padding: "4px 8px !important",
            }
        },
        MuiOutlinedInput: {
            root: {
                borderRadius: 0,
                backgroundColor: "#ffffff",
            },
            notchedOutline: {
                borderColor: "#cbd5e1",
            }
        },
        MuiAutocomplete: {
            root: {
                minHeight: 28,
            },
            inputRoot: {
                padding: "0px !important",
                minHeight: 28,
                alignItems: "center !important",
            },
            tag: {
                maxHeight: 20,
                fontSize: "10px",
                overflow: "hidden",
            },
            tagSizeSmall: {
                maxHeight: 20,
            },
            endAdornment: {
                top: "calc(50% - 12px)",
            }
        }
    }
});

function EmailParserUI(props) {

    const {
        addFleetRegionOptions = [],
        setAutoFilters = () => {},
        autoFilters = [],
        onSubmitAutoSearch = () => {}
    } = props

    const onChangeAutoFilters = (name, value) => {
        setAutoFilters({ ...autoFilters, [name]: value })
    }

    const updatedSinceLastOptions = () => {
        const arr = []
        for (let i = 0; i < 30; i++) {
            arr.push({ label: String(i + 1), value: String(i + 1) })
        }
        return arr
    }

    const labelClass = "block text-[11px] font-medium text-slate-700 mb-0.5"

    return (
        <ThemeProvider theme={compactTheme}>
            <div className="grid grid-cols-2 sm:grid-cols-12 gap-2 items-end">

                <div className="col-span-1 sm:col-span-2 min-w-0">
                    <label className={labelClass}>Updated since last</label>
                    <Autocomplete
                        options={updatedSinceLastOptions()}
                        value={autoFilters.updateSince || {}}
                        onChange={(e, value) => onChangeAutoFilters("updateSince", value)}
                        getOptionLabel={(option) => option.label}
                        size="small"
                        disableClearable
                        fullWidth
                        renderInput={(params) => (
                            <TextField {...params} variant="outlined" size="small" />
                        )}
                    />
                </div>

                <div className="col-span-1 sm:col-span-4 min-w-0">
                    <label className={labelClass}>Region</label>

                    <Autocomplete
                        multiple
                        limitTags={2}
                        options={addFleetRegionOptions}
                        value={autoFilters.portRegion || []}
                        onChange={(e, value) => onChangeAutoFilters("portRegion", value)}
                        size="small"
                        disableCloseOnSelect
                        fullWidth
                        getOptionLabel={(option) => option.label}
                        renderOption={(option, { selected }) => (
                            <>
                                <Checkbox
                                    icon={icon}
                                    checkedIcon={checkedIcon}
                                    checked={selected}
                                    size="small"
                                    style={{ marginRight: 4 }}
                                />
                                <span className="text-[11px]">{option.label}</span>
                            </>
                        )}
                        renderTags={(value, getTagProps) =>
                            value.slice(0, 2).map((option, index) => (
                                <span
                                    key={index}
                                    {...getTagProps({ index })}
                                    className="flex items-center h-[18px] px-1 mr-0.5 text-[10px] bg-slate-200 text-slate-900 overflow-hidden"
                                >
                                    {option.label}
                                </span>
                            ))
                        }
                        renderInput={(params) => (
                            <TextField {...params} variant="outlined" size="small" />
                        )}
                    />
                </div>

                <div className="col-span-1 sm:col-span-2 min-w-0">
                    <label className={labelClass}>Vessel Type</label>
                    <Autocomplete
                        options={addFleetVesselTypeOptions}
                        value={autoFilters.vesselType || {}}
                        onChange={(e, value) => onChangeAutoFilters("vesselType", value)}
                        getOptionLabel={(option) => option.label}
                        size="small"
                        disableClearable
                        fullWidth
                        renderInput={(params) => (
                            <TextField {...params} variant="outlined" size="small" />
                        )}
                    />
                </div>

                <div className="col-span-1 sm:col-span-2 min-w-0">
                    <label className={labelClass}>Gears</label>
                    <Autocomplete
                        options={addFleetGearsOptions}
                        size="small"
                        value={autoFilters.gear || {}}
                        onChange={(e, value) => onChangeAutoFilters("gear", value)}
                        getOptionLabel={(option) => option.label}
                        fullWidth
                        disableClearable
                        renderInput={(params) => (
                            <TextField {...params} variant="outlined" size="small" />
                        )}
                    />
                </div>

                <div className="col-span-2 sm:col-span-2 flex justify-end">
                    <button
                        onClick={() => onSubmitAutoSearch()}
                        className="h-7 px-3 bg-[#313C4C] hover:bg-[#1e2632] text-white text-[11px] font-medium rounded-none flex items-center justify-center gap-1.5 shadow-sm transition-colors cursor-pointer whitespace-nowrap"
                    >
                        Search
                    </button>
                </div>

            </div>
        </ThemeProvider>
    )
}

export default EmailParserUI
